export enum Environment {
  USER = 'user',
  WORKSPACE = 'workspace',
  COMMON = 'common',
}
